import * as TYPES from './_store/types';
import { buildUrl } from "@/router/index.js";
export async function asyncData(store) {
    let { type, size, baseListing, listingDetail } = this;
    let forMoreData;
    if ('forMore' in this) {
        forMoreData = this.forMore;
    } else {
        forMoreData = false;
    }
    // initial data
    let baseListingAddr = '',
        baseUrl = baseListing,
        dataType = type,
        moreLink = '',
        listing = [];

    let detail = listingDetail && listingDetail.info;
    if (forMoreData) {
        dataType = this.pageLocation.query.forMoreType || 'hot';
        if (detail) {
            baseUrl = detail.detailUrl;
            baseListingAddr = `${detail.streetAddress}, ${detail.cityAddress}`;
        }
    } else {
        dataType = dataType || 'recommend';
        var extParam = {
            forMoreType: dataType
        };
        if (dataType === 'recommend' && detail) {
            extParam['detailId'] = detail.id
        }
        if (this.isSold) {
            extParam['isSold'] = true;
        }
        moreLink = buildUrl({ name: 'house-listing',
            query: extParam })
    }
    let ps;
    switch (dataType) {
    case 'hot':
        ps = this.axiosIns.get('/api-site/listing/hot-listings', {
            params: { pageSize: size || 3 }
        });
        break;
    case 'recommend':
        ps = this.axiosIns.get('/api-site/listing/recommended-listings', {
            params: {
                pageSize: size || 3,
                detailId: (detail && detail.id) || ''
            }
        });
        break;
    default:
        ps = Promise.resolve({ data: { listing: [] } });
        break;
    }
    let res;
    if (['hot', 'recommend'].includes(dataType)) {
        res = await ps;
    } else {
        res = { data: { listing: [] } };
    }

    listing = (res.data && res.data.listings) || res.listings || [];
    store[TYPES.SET_LISTING](listing);
    store[TYPES.SET_INFO]({
        baseUrl,
        moreLink,
        baseListingAddr,
        dataType,
        forMoreData
    });
}
